<template>
	<div id="ModalMessageComponent">
		{{ message }}
	</div>
</template>

<script>
export default {
	props: [
		'message',
	],
};
</script>

<style lang="scss">
	#ModalMessageComponent {
		background-color: rgba(255, 255, 255, 0.7);
		color: #666;
		font-size: 20px;
		font-weight: bold;
		height: 100%;
		line-height: 30px;
		margin: 0;
		padding-top: 100px;
		position: absolute;
			left: 0;
			top: 0;
		text-align: center;
		white-space: pre-line;
		width: 100%;
		z-index: 100;
	}
</style>
